import { Box, BoxProps } from '@mui/material';

interface GridContainerProps extends BoxProps {
  columns: number;
  rows: number;
}

export const GridContainer = ({ columns, rows, sx, ...props }: GridContainerProps) => {
  return (
    <Box
      {...props}
      sx={{
        display: 'grid',
        gridTemplateColumns: `repeat(${columns}, 1fr)`,
        gridTemplateRows: `repeat(${rows}, 1fr)`,
        width: 'fit-content',
        height: 'fit-content',
        boxSizing: 'border-box',
        borderRadius: '8px',
        border: '1px solid var(--Gray-300, #D0D5DD)',
        overflow: 'hidden',
        flexShrink: 0,
        ...sx,
      }}
    />
  );
};
